<mat-card class="stepper-card">
  <mat-horizontal-stepper [linear]="true" (selectionChange)="stepperChange($event)" labelPosition="end">
    <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
    <mat-step>
      <ng-template matStepLabel>{{ 'Shopping Cart' | t }}</ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'Delivery & Payment' | t }}</ng-template>
    </mat-step>
    <mat-step disabled>
      <ng-template matStepLabel>{{ 'Delivery Info' | t }}</ng-template>
    </mat-step>
    <mat-step disabled>
      <ng-template matStepLabel>{{ 'Confirmation' | t }}</ng-template>
    </mat-step>
  </mat-horizontal-stepper>
</mat-card>

<ng-container *ngIf="!items.length">
  <div class="alert alert-info">
    {{ 'You have no items in your shopping cart.' | t }}
  </div>
  <button routerLink="/" mat-stroked-button color="primary">
    <icon icon="arrow_back"></icon>&nbsp;&nbsp;{{ 'Continue shopping' | t }}
  </button>
</ng-container>

<mat-card *ngIf="items.length">
  <div class="row">
    <div class="col">{{ 'Product' | t }}</div>
    <div class="col">{{ 'Price' | t }} (s DPH)</div>
    <div class="col">{{ 'Quantity' | t }}</div>
    <div class="col">{{ 'Total' | t }} (s DPH)</div>
    <div class="col">
      <button (click)="clearCart()" mat-button color="warn">
        {{ 'Clear All' | t }}
      </button>
    </div>
  </div>

  <div *ngFor="let item of items" class="row">
    <div class="col">
      <a [routerLink]="['/p/product/', item.name, item.id]">
        <div style="display: flex">
          <img [lazyLoad]="getImageUrl(item)" [alt]="item.name" [defaultImage]="defaultImage" class="col-auto" />
          <span class="col-auto">{{ item.name }}</span>
        </div>
      </a>
    </div>
    <div class="col">{{ item.price | customerPrice | localeCurrency }}</div>
    <div class="col">
      <button (click)="updateQuantity(item, item.count - 1)" mat-icon-button>
        <icon icon="remove"></icon>
      </button>
      <span class="mdc-icon-button">{{ item.count }}</span>
      <button (click)="updateQuantity(item, item.count + 1)" mat-icon-button>
        <icon icon="add"></icon>
      </button>
    </div>
    <div class="col">
      {{ item.price * item.count | customerPrice | localeCurrency }}
    </div>
    <div class="col">
      <button (click)="removeFromCart(item)" mat-mini-fab color="warn">
        <icon icon="delete"></icon>
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <button routerLink="/" mat-stroked-button color="primary">
        <icon icon="arrow_back"></icon>&nbsp;&nbsp;{{ 'Continue shopping' | t }}
      </button>
    </div>
    <div class="col">&nbsp;</div>
    <div class="col">&nbsp;</div>
    <div class="col">
      <span class="price">{{ itemsPrice | localeCurrency }}</span>
    </div>
    <div class="col">
      <button [routerLink]="checkoutLink" mat-raised-button color="primary">
        {{ 'Proceed to Checkout' | t }}&nbsp;&nbsp;<icon icon="arrow_forward"></icon>
      </button>
    </div>
  </div>
</mat-card>
